import type { PayloadAction } from "@reduxjs/toolkit";
import { DUMMY_SCHEDULE_SETTINGS } from "Data/Dummy/System";
import { createAppSlice } from "Data/Redux/Store";
import type { ScheduleSettingsState } from "Interfaces";

export const setScheduleReducer = (state: ScheduleSettingsState, action: PayloadAction<ScheduleSettingsState>) => {
	return action.payload;
};

export const getSchedule = (state: ScheduleSettingsState) => {
	return state;
};

const scheduleSlice = createAppSlice({
	name: "schedule",
	initialState: DUMMY_SCHEDULE_SETTINGS,
	reducers: {
		setScheduleAction: setScheduleReducer
	},
	selectors: {
		selectSchedule: getSchedule
	}
});

export default scheduleSlice;

export const { setScheduleAction } = scheduleSlice.actions;
export const { selectSchedule } = scheduleSlice.selectors;
